import WorkingTimeGroupComponent from "../components/WorkingTimeGroup";
import useWorkingTimeGroup from "../hooks/useWorkingTimeGroup";

const WorkingTimeGroup = () => {
    const WorkingTimeGroupProps = useWorkingTimeGroup();
    return <WorkingTimeGroupComponent {...WorkingTimeGroupProps} />;
};

export default WorkingTimeGroup;
